import API from '../libraries/API';

/**
 * Fetch all passes
 * @param {Object} [params]
 * @param {string} [params.league_acronym] - Optional league acronym
 */
const passes = ({ league_acronym = '' } = {}) => {
  const query = league_acronym ? `?league_acronym=${encodeURIComponent(league_acronym)}` : '';
  return API.get(`user/me/passes${query}`);
};


/**
 * Assign pass
 * @param {Object} params
 * @param {string} params.assign_token - Token code
 */
const assign = ({ assign_token }) => API.patch(`pass/assign/${assign_token}`);

/**
 * Activate a season OR parking code. The two kinds are indistinguishable by
 * sight, so the server resolves which it is and claims it, answering with
 * { type: 'season' | 'parking', … }. `assign` above only accepts season codes
 * and rejects a parking one as "not a ticket code".
 * @param {Object} params
 * @param {string} params.assign_token - Token code
 */
const activate = ({ assign_token }) => API.patch(`pass/activate/${assign_token}`);

export default {
  passes,
  assign,
  activate,
}
